import React, { useContext, useEffect, useState } from 'react';
import BookmarkContext from './context/BookmarkContext';
import { useNavigate } from 'react-router-dom';
import Loading from './Loading';

const VerifyEmail = () => {
  const { otp, setOtp, toast, email, APIKEY, setLoading, loading, handleClearComponent } = useContext(BookmarkContext);
  const [isResendDisabled, setIsResendDisabled] = useState(false);
  const [countdown, setCountdown] = useState(0);

  const navigate = useNavigate();

  const handleVerifyOtp = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${APIKEY}/api/userAuth/verifyOtp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, otp })
      })

      const data = await response.json();

      if (response.ok) {
        toast.success(data.message);
        setLoading(false);
        navigate("/login");
      }
      else {
        toast.error(data.message);
        setLoading(false);
      }
    } catch (error) {
      toast.error("Error While Verifying OTP");
      setLoading(false);
    }
  }

  const handleResendOtp = async () => {
    try {
      setLoading(true);
      const msg = "Verify your Email"
      const response = await fetch(`${APIKEY}/api/userAuth/resendOtp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, msg })
      })

      const data = await response.json();

      if (response.ok) {
        toast.success(data.message);
        setLoading(false);
        // Disable the resend OTP button for 10 minutes
        setIsResendDisabled(true);
        setCountdown(600);  // 10 minutes in seconds

        // Start countdown
        const interval = setInterval(() => {
          setCountdown((prevCountdown) => {
            if (prevCountdown <= 1) {
              clearInterval(interval);  // Stop the countdown
              setIsResendDisabled(false);  // Enable the button
              return 0;
            }
            return prevCountdown - 1;
          });
        }, 1000);
      } else {
        toast.error(data.message);
        setLoading(false);
      }
    } catch (error) {
      toast.error("Error While Re-Sending OTP");
      console.log("Error While Re-Sending OTP", error);
      setLoading(false);
    }
  }

  useEffect(() => {
    if (email.length === 0) {
      navigate("/login");
    }
  })


  useEffect(() => {
    handleResendOtp();
    // eslint-disable-next-line
  }, []);

  return (
    <div>
      {
        loading ? <Loading /> :
          <div className="d-flex justify-content-center align-items-center vh-100 bg-gradient" style={{
            background: 'linear-gradient(135deg, #1e3c72, #2a5298)',
            color: '#fff'
          }}>
            <div className="text-center p-2 rounded shadow" style={{ backgroundColor: 'rgba(0, 0, 0, 0.4)', maxWidth: 500 }}>
              <div className="mb-2">
                <i className="bi bi-patch-check-fill" style={{ fontSize: '2rem', color: '#4df59e' }}></i>
              </div>
              <h2 className="mb-3">Verify Your Email</h2>
              <p className="lead">
                Please check your inbox or spam folder.
              </p>

              <div className="mb-1 p-2">
                <label htmlFor="exampleInputOtp1" className="form-label text-white">Enter OTP Here:</label>
                <input
                  type="text"
                  value={otp}
                  onChange={(e) => setOtp(e.target.value)}
                  className="form-control"
                  id="exampleInputOtp1"
                  required
                />
              </div>

              <div className='d-flex justify-content-around mt-2'>
                <button className="btn btn-outline-light p-2" type="button" onClick={handleVerifyOtp} disabled={otp.length < 6}>
                  Verify OTP
                </button>

                <button
                  className="btn btn-outline-light p-2"
                  type="button"
                  onClick={handleResendOtp}
                  disabled={isResendDisabled}
                >
                  {isResendDisabled ? `Wait ${Math.floor(countdown / 60)}:${countdown % 60 < 10 ? '0' : ''}${countdown % 60}` : "Re-Send OTP"}
                </button>

                <button className="btn btn-outline-light p-2"
                  type="button"
                  onClick={() => {
                    handleClearComponent();
                    navigate("/login");
                  }}>
                  Cancel
                </button>
              </div>
            </div>
          </div>
      }
    </div>

  );
};

export default VerifyEmail;
